interface ItemInfo {
  itemHeight: number;
  itemGap: number;
  containerHeight: number;
  scrollTop: number;
  totalItems: number;
  itemsPerRow: number;
}

export const useVisibleItemIndexes = (params: ItemInfo) => {
  const { itemHeight, itemGap, containerHeight, scrollTop, totalItems, itemsPerRow = 1 } = params || {};

  if (itemHeight === 0) return { firstVisibleIndex: 0, lastVisibleIndex: 0 };

  const itemTotalHeight = itemHeight + itemGap;

  // Calculate the row of the first visible item
  const firstVisibleRow = Math.max(0, Math.floor(scrollTop / itemTotalHeight));

  // Calculate the first visible index based on the row
  const firstVisibleIndex = firstVisibleRow * itemsPerRow;

  // Calculate number of rows that can fit in the view
  const rowsInView = Math.ceil(containerHeight / itemTotalHeight);

  // Calculate the last visible row
  const lastVisibleRow = firstVisibleRow + rowsInView;

  // Calculate the last visible index based on the row and items per row
  const lastRowStartIndex = lastVisibleRow * itemsPerRow;
  const lastVisibleIndex = Math.min(totalItems - 1, lastRowStartIndex - 1 + itemsPerRow);

  return { firstVisibleIndex, lastVisibleIndex };
};
